import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBodyText, FDIcon, FDStack, FDSwitchInput, FDTableCell, FDTableRow,
} from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('ConnectionAccountLineItem', () => ({
  title: {
    verticalAlign: 'middle', // Needed or else the title text doesn't vertically align with the icon
  },
}));

export const ConnectionAccountLineItem = ({ isMobile, lineItemResource, onEditClick }) => {
  const classes = useStyles();
  const { refreshPageContentCollection } = usePageContentContext();
  const onClick = lineItemResource.withRelationship(
    fr.relationships.details.name,
    (rel) => () => onEditClick(rel),
    () => undefined,
  );
  const [submitting, setSubmitting] = useState(false);

  const toggleDisabled = async (disabled) => {
    // Shortcut for clicking on it and manually changing to disabled and submitting
    const [details] = await lineItemResource.relationship(fr.relationships.toggleDisable.name).link('related').get();
    details.attr('disabled', disabled.toString());
    setSubmitting(true);
    try {
      await details.submit();
    } catch {
      setSubmitting(false);
      return;
    }
    await refreshPageContentCollection();
    setSubmitting(false);
  };

  return (
    <FDTableRow onClick={onClick} hover>
      <FDTableCell>
        <FDStack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          flex={1}
          paddingX={isMobile ? 0 : 2}
          paddingY={2}
          spacing={2}
          wrap
        >
          <FDStack direction={'column'} flex={3} minWidth={'245px'}>
            <FDBodyText
              value={
              lineItemResource.isTruthy('isDisabled')
                ? (
                  <>
                    <FDIcon color="textDisabled" icon="visibilityOff" size="sm" />
                  &nbsp;
                    <span className={classes.title}>{lineItemResource.attr('title')}</span>
                  </>
                )
                : lineItemResource.attr('title')
            }
              color={lineItemResource.isTruthy('isDisabled') ? 'textDisabled' : undefined}
            />
            <FDBodyText
              value={lineItemResource.attr('description')}
              size="sm"
              color="textDisabled"
            />
          </FDStack>
          <FDStack alignItems={'center'} flex={2}>
            <FDStack alignItems={'center'} flex={1}>
              <FDSwitchInput
                disabled={submitting}
                onChange={toggleDisabled}
                label={lineItemResource.attr('isDisabled') === 'true' ? 'Hidden account' : 'Hide account'}
                value={lineItemResource.attr('isDisabled') === 'true'}
              />
            </FDStack>
            <FDStack alignItems={'center'} flex={1} justifyContent={'flex-end'}>
              <FDBodyText
                value={lineItemResource.attr('balance')}
                color={lineItemResource.isTruthy('isDisabled') ? 'textDisabled' : undefined}
              />
            </FDStack>
          </FDStack>
        </FDStack>
      </FDTableCell>
    </FDTableRow>
  );
};

ConnectionAccountLineItem.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  lineItemResource: PropTypes.object.isRequired,
  onEditClick: PropTypes.func.isRequired,
};
